import React from 'react';
import { ChevronRight } from 'lucide-react';

interface JourneyFlowProps {
  sections: string[];
}

const LABEL_MAP: Record<string, string> = {
  'sticky-bar': 'Audio Streaming',
};

const cleanSections = (sections: string[]): string[] => {
  const seen = new Set<string>();
  return sections.reduce<string[]>((acc, s) => {
    const label = LABEL_MAP[s] || (s.charAt(0).toUpperCase() + s.slice(1));
    if (!seen.has(label)) {
      seen.add(label);
      acc.push(label);
    }
    return acc;
  }, []);
};

const JourneyFlow: React.FC<JourneyFlowProps> = ({ sections }) => {
  const cleaned = cleanSections(sections);
  if (cleaned.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {cleaned.map((label, i) => (
        <React.Fragment key={i}>
          <span className="inline-flex items-center px-3 py-1 rounded-lg text-xs font-medium bg-secondary text-secondary-foreground">
            {label}
          </span>
          {i < cleaned.length - 1 && (
            <ChevronRight size={14} className="text-muted-foreground shrink-0" />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default JourneyFlow;
